import React from "react";
import Form from "react-bootstrap/Form";
import "./admin-group-create-panel.scss";
import SelectMemberGroup from "../../../../components/select-member/select-member-group";
import PropTypes from "prop-types";

const AdminGroupFormLeftColumnNew = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  isView,
  isEdit,
  group,
  setGroup,
}) => {
  const SaveMembers = (groupMembers, action, scroll, filter) => {
    let users = [...group.data.AllUsers];
    let nongroupMembers = users.filter(
      (user) => !groupMembers.find(({ Id }) => user.Id === Id)
    );

    // removing user - move user back down
    if (action === -1) {
      SortMembers(nongroupMembers);
    }
    // adding user - move user to top
    else {
      let added = groupMembers.find((member) => member.Id === action);
      if (added) {
        groupMembers.splice(groupMembers.indexOf(added), 1);
        groupMembers.unshift(added);
      }
    }

    users = groupMembers.concat(nongroupMembers);

    setGroup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        AllUsers: users,
        Members: groupMembers,
        selectedAllMembers: nongroupMembers.length === 0,
        selectMemberScroll: scroll,
        selectMemberFilter: filter,
      },
    }));
  };

  const SortMembers = (data) => {
    data.sort(function (a, b) {
      let textA = a.UserName.toLowerCase();
      let textB = b.UserName.toLowerCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  };

  return (
    <Form.Row className="left-row">
      <Form.Group className="group-full-name">
        <Form.Label>
          Group Name <span style={{ color: "red" }}> * </span>
        </Form.Label>
        <Form.Control
          id="Name"
          value={values?.Name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Enter Group Name"
          isInvalid={touched.Name && errors.Name}
          disabled={isView}
        />
        <Form.Control.Feedback type="invalid" className="inline-error">
          {errors.Name}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="group-assign-member">
        <h5 className="assign-member-title">
          Assign Members <span style={{ color: "red" }}> * </span>
        </h5>
        <SelectMemberGroup
          data={group?.data}
          saveMembers={SaveMembers}
          all={group?.data?.SelectedAllMembers}
          selectAll={true}
          scroll={group?.data?.SelectMemberScroll}
          filter={group?.data?.SelectMemberFilter}
          isEdit={isEdit}
          disabled={isView}
        />
        {group?.data?.Members?.length === 0 && (
          <div type="invalid" className="inline-error">
            {"Group must have at least one member"}
          </div>
        )}
      </Form.Group>
    </Form.Row>
  );
};

AdminGroupFormLeftColumnNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  isView: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  group: PropTypes.object.isRequired,
  setGroup: PropTypes.func.isRequired,
};

export default AdminGroupFormLeftColumnNew;
